import Stack from '@zenbusiness/zui/Stack';

import { QACardSkeleton } from '../components/QACard';
import { RegistrationCardSkeleton } from '../components/RegistrationCard';
import { SectionGrid } from '../components/SectionGrid';
import { WebinarCardSkeleton } from '../components/WebinarCard';
import { WEBINAR_LOCALIZED_TEXT } from '../constants';

const ITEM_LENGTH = 4;

function GettingStartedSkeleton() {
  return (
    <Stack gap={3}>
      {/* Registration Banner Skeleton */}
      <RegistrationCardSkeleton />

      <Stack gap={{ xs: 3, md: 6 }}>
        {/* Blueprint for Success Section Skeleton */}
        <SectionGrid title={WEBINAR_LOCALIZED_TEXT.sections.blueprintForSuccess}>
          {Array.from({ length: ITEM_LENGTH }, (_, index) => (
            <WebinarCardSkeleton key={`blueprint-${index}`} />
          ))}
        </SectionGrid>

        {/* Q&A section */}
        <SectionGrid title={WEBINAR_LOCALIZED_TEXT.sections.joinOurQA}>
          {Array.from({ length: ITEM_LENGTH }, (_, index) => (
            <QACardSkeleton key={`q&a-${index}`} />
          ))}
        </SectionGrid>

        {/* More Webinars Section Skeleton */}
        <SectionGrid title={WEBINAR_LOCALIZED_TEXT.sections.moreWebinars}>
          {Array.from({ length: ITEM_LENGTH }, (_, index) => (
            <WebinarCardSkeleton key={`more-webinar-${index}`} />
          ))}
        </SectionGrid>
      </Stack>
    </Stack>
  );
}

export default GettingStartedSkeleton;
